import React from "react";

const Founder = () => {
	return (
		<section className="flex lg:flex-row flex-col items-center justify-between bg-gray-100 lg:px-24 px-10 lg:py-16 py-6 text-gray-800">
			<div className="flex flex-col items-center justify-center lg:w-72 w-40">
				<img
					src="./images/founder.png"
					alt="Founder - Sri Gattu Narayana Guruji"
					className="w-full"
				/>
				<p className="mt-4 text-xl font-bold text-gray-700 text-center">
					Sri Gattu Narayana Guruji
				</p>
			</div>
			<div className="max-w-2xl">
				<h1 className="text-3xl font-bold text-gray-800 font-serif lg:block hidden">
					Sri Seetha Rama Seva Sadan
				</h1>
				<p className="lg:text-lg text-sm leading-relaxed mt-6 mb-4 text-justify">
					Sri Seetha Rama Seva Sadan was established on 02-04-2003 by Sri Gattu
					Narayana Guruji in memory of his parents, Sri Gattu Ramanna and
					Srimati Muddu Seethamma, in Manthani, which is known as Mantrakuta
					since ancient times to serve and contribute to the society and people
					of Manthani.
				</p>
				<p className="lg:text-lg text-sm leading-relaxed text-justify">
					We extend our deep thanks and gratitudes to the organisations and
					individuals who donated, contributed, or supported in our service
					programs. 80G facility regarding Income Tax exemption is available
					for contributions and donations to Sadan.
				</p>
			</div>
		</section>
	);
};

export default Founder;
